/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const FileCode16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M9.053 4.277a.499.499 0 11.894.446l-4 8a.498.498 0 01-.67.224.498.498 0 01-.224-.67zm-4.83 1.807a.5.5 0 11.554.832L2.401 8.5l2.376 1.584a.5.5 0 01-.554.833l-3-2a.5.5 0 010-.833zm6.554 0l3 2a.5.5 0 010 .832l-3 2a.5.5 0 11-.554-.832L12.599 8.5l-2.376-1.584a.5.5 0 11.554-.832z"
        />
    </AccessibleSVG>
);

export default FileCode16;
